import { useHistory, useParams } from "react-router-dom";

const ScenarioV3Route = "/scenarios-v3";

type ScenarioV3FormSubPage = "channel-spend-inputs";
type ScenarioV3ResultsSubPage = "inputs" | "results" | "likelihood";

export const getScenarioV3FormRoute = (scenarioId: string, subPage?: ScenarioV3FormSubPage) => {
  return `${ScenarioV3Route}/${scenarioId}/form${subPage ? `/${subPage}` : ""}`;
};

export const getScenarioV3ResultsRoute = (
  scenarioId: string,
  subPage?: ScenarioV3ResultsSubPage
) => {
  return `${ScenarioV3Route}/${scenarioId}${subPage ? `/${subPage}` : ""}`;
};

export const useScenariosV3Routes = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const history = useHistory();

  const navigateToScenariosList = () => {
    history.push(`${ScenarioV3Route}/all`);
  };

  const navigateToActionPlans = () => {
    history.push(`${ScenarioV3Route}/action-plans`);
  };

  const navigateToActionPlan = (actionPlanId: string) => {
    history.push(`${ScenarioV3Route}/action-plans/${actionPlanId}`);
  };

  const navigateToScenarioForm = (scenarioId: string) => {
    history.push(getScenarioV3FormRoute(scenarioId));
  };

  const navigateToChannelSpend = (scenarioId: string) => {
    history.push(getScenarioV3FormRoute(scenarioId, "channel-spend-inputs"));
  };

  const navigateToScenarioInputs = (scenarioId: string) => {
    history.push(getScenarioV3ResultsRoute(scenarioId, "inputs"));
  };

  const navigateToScenarioResults = (scenarioId: string, actionPlanUuid?: string) => {
    history.push(getScenarioV3ResultsRoute(scenarioId, "results"), { actionPlanUuid });
  };

  const navigateToScenarioLikelihood = (scenarioId: string) => {
    history.push(getScenarioV3ResultsRoute(scenarioId, "likelihood"));
  };

  return {
    uuid,
    navigateToScenariosList,
    navigateToScenarioForm,
    navigateToChannelSpend,
    navigateToScenarioInputs,
    navigateToScenarioResults,
    navigateToScenarioLikelihood,
    navigateToActionPlans,
    navigateToActionPlan,
  };
};
